import map from 'lodash/map';
import config from '../config';
import { momentParse } from '../utils/time';
import { buildImageUrl } from '../utils/images';
import * as routes from '../utils/routes';

export const buildJsonLdEvent = (event) => {
  const eventStatus = event.status === 'CANCELLED' ? 'EventCancelled' : 'EventScheduled';
  const ld =  {
    "@context": "https://www.schema.org",
    "@type": "Event",
    name: event.name,
    url: `${config().universal.baseUri}/events/${event.id}`,
    description: event.summary,
    startDate: event.startAt ? momentParse(event.startAt).format() : null,
    endDate: event.endAt ? momentParse(event.endAt).format() : null,
    eventStatus: `https://schema.org/${eventStatus}`,
    organizer: {
      '@type': event.group ? 'Organization' : 'Person',
      name: event.group ? event.group.name : event.user.displayName,
      url: routes.url(event.group ? `/groups/${event.group.slug}` : `/people/${event.user.username}`),
    },
  };
  if (event.eventType === 'ONLINE_EVENT') {
    ld.location = {
      "@type": 'VirtualLocation',
      url: event.infoUrl,
    };
  } else if (event.startLocation) {
    ld.location = {
      "@type": 'Place',
      name: event.startLocation,
      address: event.startLocationAddress,
    };
  }
  if (event.image) {
    ld.image = buildImageUrl(event.image, 'json-ld');
  }
  return ld;
};

export const buildJsonLdEvents = (events) => {
  if (!events || !events.length) {
    return [];
  }
  return map(events, buildJsonLdEvent);
};
